import { Divider, Flex, Input, Switch } from "@theorgchartdev/storybook";
import { ExportModalMode } from "../ExportModal";
import { FieldInputLabel } from "@/appComponents/Blocks/Composites/FieldInputLabel";
import type { TabProps } from "./ImageExportContent";
import { hasInvalidFilenameChars } from "../ExportModal.utils";
import { appstr } from "@coreapp/utils/appstr";

export const ImageExportGeneral = (props: TabProps) => {
  const { fieldData, onFieldChange } = props.formController;

  const showTransparentBackground = [ExportModalMode.SVG, ExportModalMode.PNG].includes(props.mode);
  const showWhiteBackground = props.mode === ExportModalMode.JPG;
  const showHighQuality = props.mode === ExportModalMode.PNG;
  const filenameError = hasInvalidFilenameChars(fieldData.name);

  return (
    <Flex direction="column" gap="6px" padding="6px 24px 0">
      <Input
        label={appstr("File Name")}
        placeholder={`${appstr("Enter")} ${appstr("File Name").toLocaleLowerCase()}`}
        size="medium"
        onChange={(_, value) => onFieldChange("name", value)}
        value={fieldData.name}
        status={filenameError ? "error" : "default"}
        message={filenameError ? appstr("exportFilenameInvalidChars") : undefined}
      />
      <Divider />
      <Flex direction="column" gap="12px">
        <FieldInputLabel id="export-crop-to-chart" helper="&nbsp;" label={appstr("croptochart")}>
          <Switch
            id="export-crop-to-chart"
            onChange={nextChecked => {
              onFieldChange("cropToChart", nextChecked);
            }}
            checked={fieldData.cropToChart}
          />
        </FieldInputLabel>
        {showTransparentBackground && (
          <FieldInputLabel
            id="export-transparent-background"
            helper="&nbsp;"
            label={appstr("transbk")}
          >
            <Switch
              id="export-transparent-background"
              onChange={nextChecked => {
                onFieldChange("transparentBackground", nextChecked);
              }}
              checked={fieldData.transparentBackground}
            />
          </FieldInputLabel>
        )}
        {showWhiteBackground && (
          <FieldInputLabel
            id="export-white-background"
            label={appstr("excludebackgrnd")}
            helper={appstr(
              "Use a white background instead of a color. This option is helpful if you plan to print this file"
            )}
          >
            <Switch
              id="export-white-background"
              onChange={nextChecked => {
                onFieldChange("whiteBackground", nextChecked);
              }}
              checked={fieldData.whiteBackground}
            />
          </FieldInputLabel>
        )}
        {showHighQuality && (
          <FieldInputLabel
            id="export-high-quality"
            label={appstr("pnghiquality")}
            helper={appstr(
              "Export a higher quality image to embed into a Word document or PowerPoint presentation"
            )}
          >
            <Switch
              id="export-high-quality"
              onChange={nextChecked => {
                onFieldChange("highQuality", nextChecked);
              }}
              checked={fieldData.highQuality}
            />
          </FieldInputLabel>
        )}
      </Flex>
    </Flex>
  );
};
